var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-wrapper",style:({height: _vm.heightFirstScreen + 'px'})},[_c('canvas',{ref:"scene",staticClass:"scene scene--full",attrs:{"id":"scene"}})])}
var staticRenderFns = []

export { render, staticRenderFns }